module.exports = __webpack_public_path__ + "static/progetto_martinetti11-6d84f64ccba45b0f50a21ce3df706ce9.jpg";